import { render, staticRenderFns } from "./TransferListTable.vue?vue&type=template&id=764377a5"
import script from "./TransferListTable.vue?vue&type=script&lang=js"
export * from "./TransferListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports